import { getAll, addClass, toArray } from '../util/dom';
import { merge } from '../util/object';

function loadImage(img) {
	img.src = img.dataset.src;
  img.removeAttribute('data-src');

  if (img.dataset.srcset) {
		img.srcset = img.dataset.srcset;
    img.removeAttribute('data-srcset');
  }

	img.onload = () => addClass(img, 'has-loaded');
}

function handleIntersection(entries, observer) {
	entries.forEach((entry) => {
		if (entry.intersectionRatio > 0 && entry.isIntersecting) {
			observer.unobserve(entry.target);
			loadImage(entry.target);
		}
	});
}

function observeImages($images, config) {
	if (!$images) return;

	// If the browser supports lazy loading, we can skip IntersectionObserver
	if (('loading' in HTMLImageElement.prototype) || !('IntersectionObserver' in window)) {
		$images.forEach(($img) => loadImage($img));
		return;
  }

	$images.forEach(($img) => new IntersectionObserver(handleIntersection, config.image).observe($img));
}

function handleMutation(mutations, selector, config) {
	mutations.map((mutation) => toArray(mutation.addedNodes).filter((node) => {
		if (!(node instanceof HTMLElement)) return false;

		return observeImages(getAll(selector, node), config.image);
	}));
}

function observeDOM(selector, config) {
	if (!('MutationObserver' in window)) return;

	new MutationObserver((mutations) => {
		handleMutation(mutations, selector, config);
	}).observe(document.documentElement, config.dom);
}

function observe(selector, config) {
	const $images = getAll(selector);

	observeDOM(selector, config);
	observeImages($images, config);
}

export function image(selector, config) {
	observe(selector, config);
}

export default function init(selector = '.image', config = {}) {
	const domConfig = merge({
		attributes: false,
		childList: true,
		subtree: true,
	}, config.dom || {});

	const imageConfig = merge({
		root: null,
		rootMargin: '100%',
		threshold: 0.1,
	}, config.image || {});

	image(`${selector}:not(.has-loaded)`, { dom: domConfig, image: imageConfig });
}
